import { use$ } from '@legendapp/state/react';

import translate from '../../../utils/translate';

import { rootStore } from '../../../store';

export interface EmissionLabelsSeparators extends EmissionLabels, TextSeparators {}

interface EmissionLabels {
	readonly modelName: string;
	readonly energyConsumptionCombinedLabel: string;
	readonly energyConsumptionWeightedLabel: string;
	readonly energyConsumptionSustainingLabel: string;
	readonly emissionLabel: string;
	readonly efficiencyClassLabel: string;
	readonly efficiencyClassWeightedLabel: string;
	readonly efficiencyClassSustainingLabel: string;
	readonly deselectableEquipmentLabel: string;
}

interface TextSeparators {
	readonly sectionSeparator: string;
	readonly consumptionEmissionsSeparator: string;
	readonly hybridValueSeparator: string;
}

export default function useEmissionLabelsSeparators() {
	const [_, currentModelValue] = use$(rootStore.currentModel);
	const modelName = currentModelValue.vehicleConfiguration?.modelName || '';

	const emissionLabels: EmissionLabels = {
		modelName,
		energyConsumptionCombinedLabel: `${translate('disclaimers.inline.efficiency.labels.wltpConsumption')}`,
		energyConsumptionWeightedLabel: `${translate(
			'disclaimers.inline.efficiency.labels.wltpConsumptionHybridWeighted'
		)}`,
		energyConsumptionSustainingLabel: `${translate(
			'disclaimers.inline.efficiency.labels.wltpConsumptionHybridSustaining'
		)}`,
		emissionLabel: translate('disclaimers.inline.efficiency.labels.emission'),
		efficiencyClassLabel: `${translate('disclaimers.inline.efficiency.labels.efficiencyClass')}`,
		efficiencyClassWeightedLabel: `${translate('disclaimers.inline.efficiency.labels.efficiencyClassHybridWeighted')}`,
		efficiencyClassSustainingLabel: `${translate(
			'disclaimers.inline.efficiency.labels.efficiencyClassHybridSustaining'
		)}`,
		deselectableEquipmentLabel: `${translate('disclaimers.inline.deselectableEquipment')}`
	};

	const textSeparators: TextSeparators = {
		sectionSeparator: translate('disclaimers.inline.efficiency.separators.component'),
		consumptionEmissionsSeparator: translate('disclaimers.inline.efficiency.separators.consumptionToEmission'),
		hybridValueSeparator: `${translate('disclaimers.inline.efficiency.separators.hybridSeparator')}`
	};

	return {
		...emissionLabels,
		...textSeparators
	};
}
